module.exports = __webpack_public_path__ + "img/frink-logo.ef816d5e.png";